import { PropsWithChildren } from 'react';
import { Widget, Container, Title } from './styled';

interface Props {
  title?: string;
  fullWidth?: boolean;
}

function PageWidget({
  title,
  fullWidth = true,
  children,
}: PropsWithChildren<Props>) {
  return (
    <Widget>
      {title && <Title>{title}</Title>}

      {!fullWidth ? <Container>{children}</Container> : children}
    </Widget>
  );
}

export { PageWidget };
